import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import "./style.scss";

const TRANSLATION_KEY = "SlotsFilled.string";

export function Content(props) {
  const { t } = useTranslation();

  const text = `${props.slotsFilled}/12 ${t(TRANSLATION_KEY)}`;
  return <div className="mc_tooltip_content">{text}</div>;
}

Content.propTypes = {
  /**
   * gives number of slots that are filled
   */
  slotsFilled: PropTypes.number,
};
Content.defaultProps = {
  slotsFilled: 0,
};
